import css from './actions.module.scss';

import cx from 'classnames';
import _ from 'lodash';
import { ComponentProps, memo } from 'react';

import Button from '../Button';
import { Menu } from '../Menu';
import { TAction } from './interface';

type Props = {
  actions: TAction[][];
  width?: string;
};

export default memo(function Actions({ actions, width }: Props) {
  const maxActionsInRow = orDie(_.maxBy(actions, row => row.length)).length;

  return (
    <div
      className={css.root}
      style={{
        gridTemplateColumns: _.times(maxActionsInRow, () => 'auto').join(' '),
        width,
      }}
    >
      {actions.map((group, idx) => (
        <ActionsRow key={idx} actions={group} />
      ))}
    </div>
  );
});

function ActionsRow({ actions }: { actions: TAction[] }) {
  return (
    <>
      {actions.map((action, idx) => (
        <Action key={idx} action={action} />
      ))}
    </>
  );
}

function Action({ action }: { action: TAction }) {
  const buttonProps: Omit<ComponentProps<typeof Button>, 'link' | 'onClick'> = {
    className: cx(css.action, action.colSpan === 2 && css.colSpan2),
    theme: 'flat',
    title: action.title,
    children: action.label ?? action.icon,
    disabled: action.disabled,
  };

  if (action.menuItems) {
    return (
      <Menu
        anchor={({ setRef, toggle }) => (
          <Button
            onRef={setRef}
            onClick={toggle}
            theme="flat"
            title="Show menu"
            children={action.icon}
            disabled={action.disabled}
          />
        )}
        children={action.menuItems}
      />
    );
  }

  return action.onClick ? (
    <Button {...buttonProps} onClick={action.onClick} />
  ) : (
    <Button {...buttonProps} link={orDie(action.link)} />
  );
}
